const items = [
  "L'Inconscio",
  "Gli Archetipi",
  "L'Individuazione",
  "Il Sogno",
  "L'Ombra",
  "Anima e Animus",
  "Il Simbolo",
  "La Persona",
];

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative border-y border-gold/15 bg-ink-soft/60 py-6 overflow-hidden select-none"
    aria-hidden="true"
  >
    <div className="marquee-track flex whitespace-nowrap w-max">
      {[0, 1].map((half) => (
        <div key={half} className="flex items-center">
          {items.map((item) => (
            <span key={`${half}-${item}`} className="flex items-center">
              <span className="font-cormorant italic text-2xl sm:text-3xl text-sand-muted/80 px-8">
                {item}
              </span>
              <svg width="14" height="14" viewBox="0 0 14 14" className="text-gold/60">
                <circle cx="7" cy="7" r="5.5" fill="none" stroke="currentColor" strokeWidth="1" />
                <circle cx="7" cy="7" r="1.5" fill="currentColor" />
              </svg>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
